// 案件状態の一本化・段1（オーナー決定 2026-08-28・A案）。
// 状態は全案件共通の1本のライフサイクル: 仮受付(sashi) → 正式(formal) → 配車済(sent)。
// 語彙は intake.js が既に持つ統一状態語彙をそのまま全入口（受付フォーム/手入力/取込）の正とする。
// 設計: engineering-タクミ/docs/2026-08-28-状態一本化-段1-設計.md
// ここに置くのは純粋関数だけ（DOM・ネットワークに触れない＝crossLink.js と同じ流儀）。

export const STATUS_LABEL = { sashi: '仮受付', formal: '正式', sent: '配車済' }

// 無指定・未知値・既存データ＝配車済（sent）。既存 trips は全部これに落ちる＝マイグレーション不要。
// 安全側＝「確定扱い」に倒す（未知値を仮受付に落とすと、確定案件がKPIから黙って消える事故になる）。
export function normalizeStatus(v) {
  return v === 'sashi' || v === 'formal' ? v : 'sent'
}

// 遷移の可否。仮受付↔正式は可逆（どちらもKPI・収支の外で実害が無い。
// chargesheet の nextSendState「未送付に戻す」と同じ、運用ミスを人が直せる思想）。
// 配車済からは戻れない（戻す＝収支の正 trips から行を抜く操作で、既存の「取消」と役割が衝突する）。
export function canTransition(from, to) {
  if (normalizeStatus(from) === 'sent') return normalizeStatus(to) === 'sent'
  return true
}

// 保存先の分岐。仮受付/正式は requests、配車済は trips。
// trips に未確定を持ち込まないことで「仮受付/正式はKPI・収支に混ぜない」が構造的に保証される
// （trips は billing/chargesheet/operations 等9ファイルが無フィルタで読む唯一の正）。
export function saveTarget(status) {
  return normalizeStatus(status) === 'sent' ? 'trips' : 'requests'
}
